import React, { useMemo } from 'react';
import styled from 'styled-components/native';
import { ViewStyle } from 'react-native';
import { Image, ImageProps } from 'expo-image';
import { AppPressable } from './app.pressable';
import { useCookies } from '@/hooks/use.cookies';
import { isHttpUrl } from '../../utils';

type ImageVariantType = 'circle' | 'curved' | 'rectangle';

interface Props extends ImageProps {
  variant?: ImageVariantType;
  containerStyle?: ViewStyle;
  onPress?: () => void;
}
function BaseAppImageView({
  variant = 'rectangle',
  contentFit = 'contain',
  placeholderContentFit = 'cover',
  cachePolicy = 'memory-disk',
  containerStyle,
  onPress,
  source,
  ...rest
}: Props) {
  const cookies = useCookies();

  let Component;
  if (variant === 'circle') {
    Component = CircleImage;
  } else if (variant === 'curved') {
    Component = CurveImage;
  } else {
    Component = RectangleImage;
  }

  const finalSource = useMemo(
    () => (typeof source === 'string' && isHttpUrl(source) ? { uri: source, headers: cookies ? { Cookie: cookies } : undefined } : source),
    [source, cookies],
  );

  if (onPress) {
    return (
      <Pressable onPress={onPress} style={containerStyle}>
        <Component contentFit={contentFit} source={finalSource} cachePolicy={cachePolicy} placeholderContentFit={placeholderContentFit} {...rest} />
      </Pressable>
    );
  }

  return <Component contentFit={contentFit} source={finalSource} cachePolicy={cachePolicy} placeholderContentFit={placeholderContentFit} {...rest} />;
}

const Pressable = styled(AppPressable)`
  user-select: none;
`;

const CircleImage = styled(Image)`
  border-radius: 1000px;
  user-select: none;
`;

const CurveImage = styled(Image)`
  border-radius: 10px;
  user-select: none;
`;

const RectangleImage = styled(Image)`
  border-radius: 0;
  user-select: none;
`;

export const AppImageView = React.memo(BaseAppImageView);
